module.exports = __webpack_public_path__ + "img/nav-layout-icon.091e3278.svg";